import React from 'react';
import RegistrationInput from '../../../UI/Registration/RegistrationInput';
import RegistrationSelect from '../../../UI/Registration/RegistrationSelect';
import { westernUnionAPI } from "../../../../util/API/westernUnion";

const WesternUnionReceiverFields = ({ receiverFields, formValues, formErrors, editFormValues, getCurrencies, getDeliveryMethods, visibleFields, requiredOverrides, handleNameTypeChange, setValueByPath, liftCascadeOptions }) => {

  const [cascadeOptions, setCascadeOptions] = React.useState({});
  const [formData, setFormData] = React.useState({});
  let tempArray = [];

  const cascadeFieldList = React.useMemo(() => (
  receiverFields
    .filter((field) => field.uiFieldType === 'CASCADE_LIST')
    .map((field) => field.name)
), [receiverFields]);

  const cascadeFieldsToFetch = React.useMemo(() => {
    return receiverFields.filter(
      (field) =>
        field.uiFieldType === 'CASCADE_LIST' &&
        field.uriIdentifier &&
        field.uriIdentifier.split('{#').length === 1
    );
  }, [receiverFields]);

  const updateCascadeOptions = (updater) => {
    setCascadeOptions((prev) => {
      const updated = typeof updater === 'function' ? updater(prev) : updater;
      liftCascadeOptions?.(updated);
      return updated;
    });
  };

  React.useEffect(() => {
    cascadeFieldsToFetch.forEach((field) => {
      getCascadeData(field);
    });
  }, [cascadeFieldsToFetch]);

  const getCascadeData = async (field, value, identifier) => {
    let sendData;
    if (!identifier || identifier < 1) {
      sendData = {
        bank: field.listId,
        branch: '',
        district: ''
      };
      setFormData(sendData);
    } else if (identifier === 1) {
      sendData = {
        ...formData,
        branch: value
      }
    } else if (identifier === 2) {
      sendData = {
        ...formData,
        district: value
      }
    }


    try {
      const response = await westernUnionAPI(sendData, "WUGetCascade");
      let list = response.payload.body.cascadeList;
      if (!Array.isArray(list)) {
        list = [list];
      }

      const options = list.map(item => ({
        label: item.displayValue,
        value: item.id,
        key: item.id
      }));

      if (!identifier || identifier < 1) {
updateCascadeOptions((prev) => ({
  ...prev,
  [field.name]: options
}));
      } else {
        let newField = tempArray[identifier];
updateCascadeOptions((prev) => ({
  ...prev,
  [newField]: options
}));
      }

    } catch (error) {
    }
  };

  const handleCascadeChange = (field, value, identifier) => {
    getCascadeData(field, value, identifier);
  }

  return (
    <>
      {receiverFields.map((field) => {
        const fieldName = field.name;
        const fieldLabel = field.label.replaceAll(/&(amp;)*#039;/g, "'");
        const fieldValue = formValues[fieldName];
        const hasError = formErrors[fieldName];
        const isNameField = fieldName.startsWith('receiver.name.');
        const isVisible = fieldName === 'receiver.name.nameType' || !isNameField || visibleFields.has(fieldName);

        if (!isVisible) return null;

        const isRequired = requiredOverrides.hasOwnProperty(fieldName)
          ? requiredOverrides[fieldName]
          : fieldName === 'sender.purposeOfTransaction' ? true : field.required === 'M';

        if (field.uiFieldType === 'TEXTFIELD') {
          return (
            <RegistrationInput
              key={fieldName}
              label={fieldLabel}
              required={isRequired}
              value={fieldValue}
              hasError={hasError}
              onChange={(e) => {
                setValueByPath(fieldName, e.target.value);
                editFormValues(fieldName, e.target.value);
              }}
            />
          );
        }

        if (field.uiFieldType === 'LIST' || field.uiFieldType === 'CASCADE_LIST') {
          const isCascade = field.uiFieldType === 'CASCADE_LIST';
          if (isCascade) {
            tempArray.push(fieldName);
          }
          const options = isCascade
            ? cascadeOptions[fieldName] || []
            : Array.isArray(field.listValue)
              ? field.listValue.map((item) => ({
                key: item.id,
                value: item.id,
                label: item.displayValue,
              }))
              : [{key: field.listValue.id, value: field.listValue.id, label: field.listValue.displayValue}];

          const isNameType = fieldName === "receiver.name.nameType";

          return (
            <RegistrationSelect
              key={fieldName}
              label={fieldLabel}
              required={isRequired}
              value={fieldValue}
              hasError={hasError}
              options={options}
              onChange={(e) => {
                const value = e.target.value;
                setValueByPath(fieldName, value);
                editFormValues(fieldName, value);
                if (isNameType) {
                  handleNameTypeChange(value);
                }
                if (isCascade) {
                  handleCascadeChange(field, value, field.uriIdentifier.split('{#').length);
                }
              }}
            />
          );
        }

        return null;
      })}
    </>
  );
};

export default WesternUnionReceiverFields;
